import {useLayoutEffect,useRef} from 'react';

// Shared behavior for every road and line-chart viewport.
export function useRoadScroll(resetKey) {
 const root=useRef(null);
 useLayoutEffect(()=>{
  const cleanups=[];
  root.current?.querySelectorAll('.pc-road-scroll').forEach(view=>{
   let drag=null;
   const right=()=>{view.scrollLeft=Math.max(0,view.scrollWidth-view.clientWidth);};
   right();
   const observer=typeof ResizeObserver==='undefined'?null:new ResizeObserver(right);
   observer?.observe(view);
   if(view.firstElementChild) observer?.observe(view.firstElementChild);
   const stop=()=>{drag=null;view.classList.remove('road-dragging');};
   const down=e=>{
    if(e.pointerType!=='mouse'||e.button!==0||view.scrollWidth<=view.clientWidth)return;
    const box=view.getBoundingClientRect();
    // Keep the native scrollbar usable.
    if(e.clientY-box.top>=view.clientHeight||e.clientX-box.left>=view.clientWidth)return;
    drag={id:e.pointerId,x:e.clientX,left:view.scrollLeft};
    view.setPointerCapture(e.pointerId);view.classList.add('road-dragging');e.preventDefault();
   };
   const move=e=>{if(drag&&drag.id===e.pointerId)view.scrollLeft=drag.left-(e.clientX-drag.x);};
   const up=e=>{if(drag&&drag.id===e.pointerId){if(view.hasPointerCapture(e.pointerId))view.releasePointerCapture(e.pointerId);stop();}};
   view.addEventListener('pointerdown',down);view.addEventListener('pointermove',move);view.addEventListener('pointerup',up);view.addEventListener('pointercancel',up);view.addEventListener('lostpointercapture',stop);
   cleanups.push(()=>{observer?.disconnect();stop();view.removeEventListener('pointerdown',down);view.removeEventListener('pointermove',move);view.removeEventListener('pointerup',up);view.removeEventListener('pointercancel',up);view.removeEventListener('lostpointercapture',stop);});
  });
  return ()=>cleanups.forEach(clean=>clean());
 },[resetKey]);
 return root;
}
